import type { IconData } from '@stacksjs/iconify-core'

export const smallArrowUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 310q0-10 7-16l162-163q7-7 17-7t16 7l162 163q7 7 7 16t-7 16t-16 7t-17-7L185 181L39 326q-7 7-16 7t-16-6.5T0 310\"/>",
  "width": 380,
  "height": 700,
  "viewBox": "0 0 380 700"
}

export default smallArrowUp
